/**
 * Caygoder
 * Jan 07, 2026
 * DNA Asset - Number Lock & Customization
 * Handles validation and locking of jersey numbers against Supabase.
 * Jan 14, 2026
 * Added fee calculation logic based on metafield toggle.
 */

document.addEventListener('DOMContentLoaded', function() {
  const containers = document.querySelectorAll('.dna-customization-wrapper');

  if (containers.length === 0) return;

  const config = window.DNA_CONFIG || {};
  const isDebug = config.debug === true;

  function debugLog(...args) {
    if (isDebug) console.log(...args);
  }
  function debugWarn(...args) {
    if (isDebug) console.warn(...args);
  }
  function debugAlert(msg) {
    if (isDebug) alert(msg);
  }

  debugLog('DNA Customization: Found ' + containers.length + ' container(s).');

  if (!config.supabaseUrl || !config.supabaseAnonKey) {
    debugWarn('DNA Customization: Supabase configuration missing. Number lock will not function.');
  }

  containers.forEach(container => {
    const isLockEnabled = container.dataset.numberLockEnabled === 'true';
    const isFeeEnabled = container.dataset.feeEnabled !== 'false';
    const accountTags = container.dataset.accountTags;

    if (isLockEnabled) {
      if (!accountTags) {
        debugWarn('DNA Customization: Missing Account Tags for lock logic.');
        return;
      }
      debugLog('DNA Customization: Number Lock is ENABLED. Scanning tags:', accountTags);
      initNumberLock(container, accountTags, config, true);
    } else {
       if (isFeeEnabled) {
           debugLog('DNA Customization: Lock Disabled, but Fee Enabled. Initializing interceptor.');
           initNumberLock(container, accountTags, config, false);
       } else {
           debugLog('DNA Customization: Standard customization only (No Lock, No Fee).');
       }
    }
  });

  function initNumberLock(container, accountTags, config, isLockActive) {
    const isFeeEnabled = container.dataset.feeEnabled !== 'false'; // Default to true if missing

    const eventSelect = container.querySelector('select[name="properties[Event]"], select[name="properties[Season]"]');
    const teamSelect = container.querySelector('select[name="properties[Team]"]');
    const nameInput = container.querySelector('input[name="properties[Name]"]');
    const numberInput = container.querySelector('input[name="properties[Number]"]');
    const topSizeField = container.querySelector('[name="properties[Top Size]"]');
    const bottomSizeField = container.querySelector('[name="properties[Bottom Size]"]');
    const validationMsg = container.querySelector('.validation-message');
    const eventPropertyKey = eventSelect && eventSelect.name === 'properties[Season]' ? 'Season' : 'Event';

    // Hidden inputs to populate
    const accountIdInput = container.querySelector('input[name="properties[_Account ID]"]');
    const eventIdInput = container.querySelector('input[name="properties[_Event ID]"]');

    // State
    let currentState = {
      accountId: null,
      eventId: null,
      teamId: null
    };

    // Enforce formats
    if (nameInput) {
      nameInput.addEventListener('input', function() {
        this.value = this.value.toUpperCase();
      });
    }
    // Fix: Respect maxlength attribute for number input
    if (numberInput) {
      numberInput.addEventListener('input', function() {
        // Use maxLength from attribute if available, otherwise default to 3
        const max = this.maxLength && this.maxLength > 0 ? this.maxLength : 3;
        this.value = this.value.replace(/[^0-9]/g, '').slice(0, max);
      });
    }

    // 0. Fetch Account ID (via Tags) + Events + Teams - ONLY IF LOCK ACTIVE
    if (isLockActive) {
        fetchAccountDetails(config, accountTags)
        .then(data => {
            if (!data || !data.accountId) {
            debugWarn('DNA: Could not find account matching tags: ' + accountTags);
            // Disable inputs?
            if (teamSelect) teamSelect.innerHTML = '<option disabled>Account not found</option>';
            if (eventSelect) eventSelect.innerHTML = '<option disabled>Account not found</option>';
            return;
            }

            debugLog('DNA: Found Account:', data.accountId);
            currentState.accountId = data.accountId;
            if (accountIdInput) accountIdInput.value = data.accountId;

            // Populate Events (Newest First)
            if (eventSelect && data.events && data.events.length > 0) {
            eventSelect.innerHTML = ''; // Clear loading
            data.events.forEach((evt, idx) => {
                const opt = document.createElement('option');
                opt.value = evt.name; 
                opt.dataset.id = evt.id;
                opt.textContent = evt.name;
                if (idx === 0) {
                    opt.selected = true;
                    currentState.eventId = evt.id;
                    if (eventIdInput) eventIdInput.value = evt.id;
                }
                eventSelect.appendChild(opt);
            });
            
            // Listener for Event Change
            eventSelect.addEventListener('change', function() {
                const selectedOpt = this.options[this.selectedIndex];
                if (selectedOpt) {
                    currentState.eventId = selectedOpt.dataset.id;
                    if (eventIdInput) eventIdInput.value = currentState.eventId;
                    // Re-validate logic if number is entered?
                }
            });
            } else if (eventSelect) {
            eventSelect.innerHTML = '<option disabled>No events found</option>';
            }

            // Populate Teams (Alphabetical)
            if (teamSelect && data.teams && data.teams.length > 0) {
            teamSelect.innerHTML = '<option value="" disabled selected>Select Team</option>';
            data.teams.forEach(team => {
                const opt = document.createElement('option');
                opt.value = team.name; 
                opt.dataset.id = team.id;
                opt.textContent = team.name;
                teamSelect.appendChild(opt);
            });
            
            // Listener for Team Change
            teamSelect.addEventListener('change', function() {
                const selectedOpt = this.options[this.selectedIndex];
                if (selectedOpt) {
                    currentState.teamId = selectedOpt.dataset.id;
                }
            });
            } else if (teamSelect) {
            teamSelect.innerHTML = '<option disabled>No teams found</option>';
            }
        })
        .catch(err => console.error('DNA Init Error:', err));
    }


    // 1. Validate Number (Format Only) - ONLY IF LOCK ACTIVE (Optional: Keep strict format for consistency?)
    // Let's keep strict format enforcement regardless of lock, it's good UX.
    // BUT the debounce check for availability was removed anyway.
    if (numberInput) {
      numberInput.addEventListener('input', debounce(function(e) {
        const val = e.target.value;
        const msgId = validationMsg.id;
        const msgEl = document.getElementById(msgId);
        
        // Reset valid state
        setValidity(numberInput, msgEl, true);

        if (!val) return;

        // Basic format check
        const num = parseInt(val, 10);
        if (isNaN(num) || num < 0 || num > 999) {
           setValidity(numberInput, msgEl, false, 'Number must be between 0 and 999.');
           return;
        }

        // Note: Real-time availability check removed to improve security and performance.
        // Availability is confirmed atomically when "Add to Cart" is clicked.
      }, 500));
    }

    const form = container.closest('form[action="/cart/add"]');
    const addToCartBtn = form ? form.querySelector('[name="add"]') : null;

    // 2. Intercept Add to Cart
    if (addToCartBtn) {
      addToCartBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        if (topSizeField && !topSizeField.value) {
            alert('Please select top size.');
            return;
        }

        if (bottomSizeField && !bottomSizeField.value) {
          alert('Please select bottom size.');
          return;
        }

        // Checks dependent on Lock Status
        if (isLockActive) {
            // Basic checks
            if (teamSelect && !teamSelect.value) {
                alert('Please select a team.');
                return;
            }
            if (eventSelect && !eventSelect.value) {
              alert(eventPropertyKey === 'Season' ? 'Please select a season.' : 'Please select an event.'); 
                return;
            }
            if (numberInput && !numberInput.value) {
                alert('Please enter a number.');
                return;
            }
            
            // Frontend validation check
            if (numberInput && numberInput.classList.contains('input-error')) {
                alert('Please fix the errors before continuing.');
                return;
            }
        }
        
        const btnText = addToCartBtn.querySelector('[data-add-to-cart-text]');
        const originalText = btnText ? btnText.textContent : 'Add to Cart';
        
        if (btnText) btnText.textContent = 'Checking...';
        addToCartBtn.disabled = true;

        const numberVal = numberInput ? parseInt(numberInput.value, 10) : 0;
        
        // Caygoder 011426: Separate Product ID (for Lock) and Variant ID (for Cart)
        const variantId = getVariantId(form);
        const realProductId = getProductId(form);

        debugLog('DNA Debug: Intercepted', { isLockActive, accountId: currentState.accountId, productId: realProductId, variantId, number: numberVal });

        // Branch: If Lock Active -> Reserve. If NOT Active -> Skip Reserve, Go to Fee Logic directly.
        
        if (isLockActive) {
            if (!realProductId) {
                console.error('DNA Error: Product ID not found in form.');
                alert('System Error: Product ID missing for reservation.');
                if (btnText) btnText.textContent = originalText;
                addToCartBtn.disabled = false;
                return;
            }

            const currentCartToken = getCartToken();
            const lineKey = 'dna_' + Math.random().toString(36).substr(2, 9);
    
            debugLog('DNA Debug: Reservation Payload Details', {
                cartToken: currentCartToken,
                lineKey: lineKey,
                productId: realProductId
            });
    
            // Reserve
            reserveNumber(config, {
              accountId: currentState.accountId,
              teamId: currentState.teamId,
              eventId: currentState.eventId,
              variantId: realProductId, 
              number: numberVal,
              shopDomain: config.shopDomain,
              cartToken: currentCartToken,
              lineKey: lineKey,
            })
            .then(res => handleReservationResult(res, variantId))
            .catch(err => {
                console.error(err);
                alert('Error during reservation. Please try again.');
                resetButton();
            });
        } else {
            // Lock Disabled: Directly Process Logic (Fee or Submit) without Reservation ID
            // Simulate a "Success" response but with no reservationId
            handleReservationResult({ ok: true, reservationId: null }, variantId);
        }

        // --- Inner Handling Logic to deduplicate Fee Logic ---

        function resetButton() {
             if (btnText) btnText.textContent = originalText;
             addToCartBtn.disabled = false;
        }

        function handleReservationResult(res, variantId) {
           if (res.ok) {
             if (isLockActive) debugLog('Reservation successful:', res);
             
             // Calculate Fee Logic
             const feeId = config.feeVariantId;
             let feeQty = 0;
             if (config.feeVariantId && isFeeEnabled) {
                if (nameInput && nameInput.value.trim()) feeQty++;
                if (numberInput && numberInput.value.trim()) feeQty++;
             }

             debugLog('DNA Debug: Fee Logic', { 
                 feeId: feeId, 
                 feeQty: feeQty, 
                 isFeeEnabled: isFeeEnabled,
                 isLockActive: isLockActive
             });

             // Debug / Validation
             if (feeQty > 0 && !variantId) {
                 debugWarn('DNA: Fee applicable but Variant ID missing. Falling back to form submit.');
                 feeQty = 0; // Force standard submit
             }

             if (feeQty > 0) {
                // Add Main Item + Fee Item via AJAX
                
                // Construct properties object
                let props = {
                  'Number': numberInput ? numberInput.value : '',
                  'Top Size': topSizeField ? topSizeField.value : '',
                  'Bottom Size': bottomSizeField ? bottomSizeField.value : ''
                };

                if (nameInput) {
                    props['Name'] = nameInput.value.toUpperCase();
                }
                
                // Only add lock-specific props if they exist/matter
                if (isLockActive) {
                  props[eventPropertyKey] = eventSelect ? eventSelect.value : '';
                    props['Team'] = teamSelect ? teamSelect.value : '';
                    props['_Account ID'] = accountIdInput ? accountIdInput.value : '';
                    props['_Event ID'] = eventIdInput ? eventIdInput.value : '';
                    props['_DNA_Reservation_ID'] = res.reservationId || '';
                }

                // Construct payload
                const itemsToCart = [
                    {
                        id: variantId,
                        quantity: 1,
                        properties: props
                    },
                    {
                        id: feeId,
                        quantity: feeQty
                    }
                ];

                const cartAddUrl = (window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart/add.js';
                // Remove double slashes if root is '/'
                const cleanUrl = cartAddUrl.replace('//', '/');

                debugLog('DNA Debug: Adding to cart via AJAX', itemsToCart);

                fetch(cleanUrl, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ items: itemsToCart })
                })
                .then(cRes => cRes.json())
                .then(cartRes => {
                    debugLog('DNA Debug: Cart Response', cartRes);
                    if ((cartRes.status && cartRes.status !== 200) || cartRes.errors || cartRes.description) { 
                         console.error('Cart Add Error:', cartRes);
                         const desc = cartRes.description || cartRes.errors || "Unknown error";
                         alert('Error adding to cart: ' + desc);
                         resetButton();
                    } else if (cartRes.items && cartRes.items.length === 0) {
                         console.error('Cart Add Empty:', cartRes);
                         alert('Cart update failed (Empty response). Please try again.');
                         resetButton();
                    } else {
                         debugLog('DNA Debug: Cart add success.');
                         debugAlert('DNA Debug: Items added to cart.\n\nClick OK to proceed to cart.');
                         window.location.assign('/cart?v=' + new Date().getTime());
                    }
                })
                .catch(err => {
                    console.error('Cart Add Network Error', err);
                    HTMLFormElement.prototype.submit.call(form);
                });

             } else {
                // No Fee, Standard Submit
                // Inject Reservation ID if it exists
                if (res.reservationId) {
                  const inputName = 'properties[_DNA_Reservation_ID]';
                  let hidden = form.querySelector(`input[name="${inputName}"]`);
                  if (!hidden) {
                    hidden = document.createElement('input');
                    hidden.type = 'hidden';
                    hidden.name = inputName;
                    form.appendChild(hidden);
                  }
                  hidden.value = res.reservationId;
                }
                HTMLFormElement.prototype.submit.call(form);
             }

           } else {
             alert('Could not reserve number: ' + (res.error || 'Unknown error'));
             resetButton();
           }
        }
      });
    }
  }

  // --- Helpers ---

  function setValidity(input, msgEl, isValid, message) {
     if (isValid) {
        input.setCustomValidity("");
        input.classList.remove('input-error');
        if (msgEl) {
            msgEl.style.display = 'none';
            msgEl.textContent = '';
        }
     } else {
        input.setCustomValidity(message);
        input.classList.add('input-error'); 
        if (msgEl) {
            msgEl.style.display = 'block';
            msgEl.textContent = message;
        }
     }
  }

  // --- API ---

  async function fetchAccountDetails(config, accountTagsRaw) {
    // Call Edge Function 'get-account-details'
    try {
        const url = `${config.supabaseUrl}/functions/v1/get-account-details`;
        const res = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${config.supabaseAnonKey}`,
                'apikey': config.supabaseAnonKey
            },
            body: JSON.stringify({ tags: accountTagsRaw })
        });
        
        if (!res.ok) {
           console.error('get-account-details error', await res.text());
           return null;
        }

        const data = await res.json();
        // Edge function returns { accountId, events: [], teams: [] } or { found: false, message: ... }
        if (!data.accountId) {
             console.warn('DNA: Account lookup returned no account.', data);
             return null;
        }

        return data; 

    } catch (e) {
        console.error('Fetch Account Details Logic Failed:', e);
        return null;
    }
  }

  // checkAvailability function removed - we check on Reserve

  async function reserveNumber(config, payload) {
      const url = `${config.supabaseUrl}/functions/v1/reserve-number`;
      const res = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${config.supabaseAnonKey}`,
             'apikey': config.supabaseAnonKey
          },
          body: JSON.stringify(payload)
      });
      return await res.json();
  }

  function debounce(func, wait) {
    let timeout;
    return function(...args) {
      const context = this;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), wait);
    };
  }

  function getProductId(form) {
      const input = form.querySelector('input[name="data-product-id"]');
      return input ? input.value : '';
  }

  function getVariantId(form) {
      const variantInput = form.querySelector('[name="id"]');
      return variantInput ? variantInput.value : '';
  }

  function getCartToken() {
     // Shopify doesn't expose cart token easily in JS without reading cookies or Ajax API.
     // Common cookie is 'cart'.
     return getCookie('cart');
  }

  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  }

});
